import {ModuleWithProviders, NgModule} from '@angular/core';
import { NebulaConfigService} from '@scientifica-cms-fe/services/config/config.service';
import {NEBULA_APP_CONFIG} from '@scientifica-cms-fe/services/config/config.constants';

@NgModule()
export class NebulaConfigModule {
    /**
     * Constructor
     */
    constructor(private _nebulaConfigService: NebulaConfigService) {
    }

    /**
     * forRoot method for setting user configuration
     *
     * @param config
     */
    static forRoot(config: any): ModuleWithProviders<NebulaConfigModule> {
        return {
            ngModule: NebulaConfigModule,
            providers: [
                {
                    provide: NEBULA_APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
